import { render, staticRenderFns } from "./BatchSetting.vue?vue&type=template&id=1e61d230&scoped=true"
import script from "./BatchSetting.vue?vue&type=script&lang=js"
export * from "./BatchSetting.vue?vue&type=script&lang=js"
import style0 from "./BatchSetting.vue?vue&type=style&index=0&id=1e61d230&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61d230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e61d230')) {
      api.createRecord('1e61d230', component.options)
    } else {
      api.reload('1e61d230', component.options)
    }
    module.hot.accept("./BatchSetting.vue?vue&type=template&id=1e61d230&scoped=true", function () {
      api.rerender('1e61d230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/BatchSetting.vue"
export default component.exports